// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3k762","title":"AfterFrontImage_title__RFuYk"};